import { Injectable } from '@angular/core';
import {AuthHttp} from '../auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class RoleService {
  private endpoint = 'roles';
  constructor(private http: AuthHttp) { }

  getRoles() {
    return this.http.get(`${environment.baseUrl}${this.endpoint}`)
      .map(res => res.json())
      .toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/services/role/role.service.ts